// Rich-text fields store `<!-- venue-rich-text:v1 -->` followed by editor HTML; any value without
// that prefix is literal plain text. These helpers flatten a stored value to plain text without
// loading the editor, so labels, search, AI prompts and emails never show markup.
// public.flatten_rich_text / public.rich_text_is_blank in SQL follow the same steps; keep the
// three in step (docs/rich-text-fields.md).

export const RICH_TEXT_PREFIX = '<!-- venue-rich-text:v1 -->';

export function isRichTextValue(value) {
  return typeof value === 'string' && value.startsWith(RICH_TEXT_PREFIX);
}

/** Plain values come back unchanged; rich values become trimmed text with one newline per block. */
export function flattenRichText(value) {
  if (value == null) return '';
  const text = String(value);
  if (!text.startsWith(RICH_TEXT_PREFIX)) return text;
  return text.slice(RICH_TEXT_PREFIX.length)
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(?:p|h[1-6]|li|blockquote)>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/\n[ \t]*(?:\n[ \t]*)+/g, '\n')
    .trim();
}

/** True when a plain or rich value holds no visible text (an empty editor stores `<p></p>`). */
export function isRichTextBlank(value) {
  return flattenRichText(value).trim() === '';
}
